// Environment configuration loader
// Reads from .env file via Vite's import.meta.env

export interface EnvConfig {
  openai: {
    apiKey?: string
    model: string
    temperature: number
  }
  browser: {
    type: 'chromium' | 'firefox' | 'webkit'
    headless: boolean
    timeout: number
  }
  theme: 'light' | 'dark' | 'system'
}

function parseBoolean(value: string | undefined, defaultValue: boolean): boolean {
  if (value === undefined) return defaultValue
  return value.toLowerCase() === 'true'
}

function parseNumber(value: string | undefined, defaultValue: number): number {
  if (value === undefined) return defaultValue
  const parsed = parseInt(value, 10)
  return isNaN(parsed) ? defaultValue : parsed
}

function parseFloat_(value: string | undefined, defaultValue: number): number {
  if (value === undefined) return defaultValue
  const parsed = parseFloat(value)
  return isNaN(parsed) ? defaultValue : parsed
}

export function getEnvConfig(): EnvConfig {
  return {
    openai: {
      apiKey: import.meta.env.VITE_OPENAI_API_KEY || undefined,
      model: import.meta.env.VITE_OPENAI_MODEL || 'gpt-4o',
      temperature: parseFloat_(import.meta.env.VITE_OPENAI_TEMPERATURE, 0.2),
    },
    browser: {
      type: (import.meta.env.VITE_BROWSER_TYPE as 'chromium' | 'firefox' | 'webkit') || 'chromium',
      headless: parseBoolean(import.meta.env.VITE_BROWSER_HEADLESS, true),
      timeout: parseNumber(import.meta.env.VITE_BROWSER_TIMEOUT, 30000),
    },
    theme: (import.meta.env.VITE_DEFAULT_THEME as 'light' | 'dark' | 'system') || 'system',
  }
}

// Check if a specific env var is set (for UI display)
export function isEnvConfigured(key: string): boolean {
  return !!import.meta.env[key]
}

export function getEnvApiKey(): string | undefined {
  return import.meta.env.VITE_OPENAI_API_KEY || undefined
}
